/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Error Boundary Enhanced
 *
 * Main export file for error boundary components.
 * Refactored for modularity - extracted fallback components and specialized boundaries.
 */

export { DefaultErrorFallback } from "./components/default-error-fallback";
export {
  DashboardErrorBoundary,
  FeatureErrorBoundary,
  FormErrorBoundary,
} from "./components/specialized-boundaries";
export { ErrorBoundary } from "./error-boundary";

export type { ErrorFallbackProps } from "./components/default-error-fallback";
export type {
  ErrorBoundaryProps,
  ErrorBoundaryState,
  ErrorInfo,
} from "./error-boundary";
